export enum StaticToastTypes {
  'SUCCESS' = 'success',
}
